import { Field, FieldContainer, Label, RadioGroup } from '@cademy-ui/form';
import { FunctionComponent, useId, useMemo } from 'react';
import styles from './styles.module.scss';
import { CourseKeyword, CourseType } from '@shared/types';
import { Button } from '../../../Button';

export type BookerIsAttendingFieldProps = {
    name: string;
    courseKeyword?: CourseKeyword;
    courseType: CourseType;
};

export const BookerIsAttendingField: FunctionComponent<BookerIsAttendingFieldProps> = ({
    name,
    courseKeyword,
    courseType,
}) => {
    const id = useId();

    const question = useMemo(() => {
        if (courseType === 'on-demand' || courseType === 'blended') {
            return `Do you wish to enroll yourself into this ${courseKeyword || 'course'}?`;
        }
        return `Will you attend this ${courseKeyword || 'course'}?`;
    }, [courseKeyword, courseType]);

    const negativeOption = useMemo(() => {
        if (courseType === 'on-demand' || courseType === 'blended') {
            return 'No, I wish to enroll someone else';
        }
        return 'No, I am booking for someone else';
    }, [courseType]);

    return (
        <Field<boolean> name={name} initialValue={true} required={true}>
            {({ value, setValue, descriptionId, errorId, errors }) => {
                return (
                    <FieldContainer
                        className={styles.container}
                        descriptionId={descriptionId}
                        errorId={errorId}
                        errors={errors}
                    >
                        <Label id={`${id}_isAttendingSelect`}>{question}</Label>
                        <RadioGroup
                            aria-labelledby={`${id}_isAttendingSelect`}
                            className={styles.select}
                            options={[true, false]}
                            value={value}
                            onChange={setValue}
                        >
                            {({ option, isSelected }) => {
                                const text = option === false ? negativeOption : 'Yes';
                                return (
                                    <Button preset={isSelected ? 'primary' : 'default'}>
                                        {text}
                                    </Button>
                                );
                            }}
                        </RadioGroup>
                    </FieldContainer>
                );
            }}
        </Field>
    );
};
